<template>
	<div class="gift-present">
		<div ref="prebtn" class="present-btn" v-show="anchors.length" @click="show"><slot></slot></div>
		<div v-if="showPopover" class="gift-present-bg" @click="close"></div>
		<div v-if="showPopover" ref="content" class="gift-choose">
			<div ref="arrow" class="arrow"></div>
			<div class="top">
				<div class="left">礼物</div>
				<div class="right" @click="serviceNotice">服务声明</div>
			</div>
			<div class="gift-content">
				<van-grid :column-num="4">
					<van-grid-item
						v-for="(item, index) in gifts"
						:key="index"
						:class="{ choosed: item.id === currGift.id ? true : false }"
						@click="chooseGift(item)"
					>
						<div class="gift-image">
							<img :src="item.url" />
						</div>
						<div class="name">{{ item.name }}</div>
					</van-grid-item>
				</van-grid>
			</div>
			<div class="buttom">
				<span style="margin-left: 10px">送给</span>
				<van-cell-group>
					<van-field v-model="currAnchor.nick_name" @click="userPicker = true" disabled>
						<template v-slot:left-icon>
							<div class="holder">
								<img :src="currAnchor.avatar" />
							</div>
						</template>
						<template v-slot:right-icon> <van-icon name="arrow-down" size:="8"/> </template>
					</van-field>
				</van-cell-group>
				<van-popup v-model="userPicker" position="bottom">
					<van-picker show-toolbar :columns="anchors" :value-key="'nick_name'" @confirm="onConfirmUser" @cancel="userPicker = false"
				/></van-popup>
				<van-cell-group class="account">
					<van-field v-model="account" disabled @click="accountPicker = true">
						<template v-slot:left-icon>
							<span>数量:</span>
						</template>
						<template v-slot:right-icon>
							<div style="display: flex; align-items: center">
								<van-icon name="arrow-down" size:="8" v-if="gifts.length!=0"/>
								<div class="button" v-if="gifts.length != 0" @click.stop="presentHandle">赠送</div>
							</div>
						</template>
					</van-field>
				</van-cell-group>
				<van-popup v-model="accountPicker" position="bottom">
					<van-picker show-toolbar :columns="columnsAccount" @confirm="onConfirmAccount" @cancel="accountPicker = false"
				/></van-popup>
			</div>
		</div>
		<van-dialog class="qr-dialog" v-model="qrShow" width="300px" :show-confirm-button="false" :closeOnClickOverlay="true">
			<div class="attractCode">
				<div class="title">服务声明</div>
				<div class="desc">
					您好，打赏是用户自愿赠与主播/管理员的虚拟商品，直播打赏须理性。同时直播打赏为用户自愿支付行为。支付完成后，除因法定情形规定或者违反其他相关规定的情况外，支付金额不支持退款。
				</div>

				<div class="delButton" style="" @click="qrShow = false"><van-icon name="cross" color="#bbb" /></div>
			</div>
		</van-dialog>
	</div>
</template>

<script>
import { anchorList, getGift } from "@/api/live.js";

export default {
  props: {
    live_id: {
      type: [String, Number]
    }
  },
	data() {
		return {
			showPopover: false,
			gifts: [],
			userPicker: false,
			currGift: {},
			anchors: [],
			currAnchor: {},
			columnsAccount: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 66, 88, 99],
			accountPicker: false,
			account: 1,
			qrShow: false,
		};
	},
	computed: {},
	watch: {
		showPopover(newV, oldV) {
			if (newV) {
				this.init();
			}
		},
	},
	mounted() {
    this.init();
  },
	beforeDestroy() {},
	methods: {
		async show() {
			if (this.showPopover) {
				this.showPopover = false;
				return;
			}
			this.showPopover = true;
			this.$nextTick(() => {
				const prebtn = this.$refs.prebtn;
				const contentDom = this.$refs.content;
				const arrowDom = this.$refs.arrow;
				const top = prebtn.getBoundingClientRect().top - contentDom.getBoundingClientRect().height;
				contentDom.style.top = `${top - 10}px`;
				arrowDom.style.left = `${prebtn.getBoundingClientRect().left + prebtn.getBoundingClientRect().width / 2}px`;
			});
		},
		close() {
			this.showPopover = false;
		},

		serviceNotice() {
			this.qrShow = true;
		},

		async init() {
			if (this.gifts.length > 0 && this.anchors.length > 0) {
				return;
			}
			const giftRes = await getGift();
			this.gifts = giftRes.result.data

			const anchorRes = await anchorList({ live_id: this.live_id });
			this.anchors = anchorRes.result;
			this.currAnchor = this.anchors[0];
		},

		chooseGift(gift) {
			this.currGift = gift;
			console.log("chooseGift", this.currGift);
		},
		onConfirmUser(value, index) {
			console.log("onConfirmUser", value, index);
			this.currAnchor = value;
			this.userPicker = false;
		},
		onConfirmAccount(num) {
			console.log("onConfirmAccount", num);
			this.account = num;
			this.accountPicker = false;
		},

		presentHandle() {
			const obj = {
				gift: this.currGift,
				anchor: this.currAnchor,
				count: Number(this.account),
			};
			// console.log("presentHandle", obj);
			this.$emit("present-gift", obj);
			this.close();
		},
	},
};
</script>

<style lang="less" scoped>
@import "../chat.less";
.qr-dialog {
	.attractCode {
		position: relative;
		box-sizing: border-box;
		padding: 15px 20px;
		.title {
			font-size: 18px;
			font-weight: bold;
		}
		.desc {
			text-align: left;
			margin-top: 15px;
		}
		.delButton {
			position: absolute;
			background-color: #000;
			border: 1px solid #fff;
			border-radius: 50%;
			display: flex;
			align-items: center;
			justify-content: center;
			height: 20px;
			width: 20px;
			left: 90%;
			top: 5px;
		}
	}
}
.gift-present {
	position: relative;
	// > .present-btn {
	// }
	.gift-present-bg {
		background-color: transparent;
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 1;
	}
	> .gift-choose {
		box-sizing: border-box;
		border: 1px solid #a6a8b1;
		border-radius: 10px;
		position: fixed;
		left: 0;
		bottom: 0;
		z-index: 9;
		width: 100%;
		height: 300px;
		box-sizing: border-box;
		padding: 10px 15px 40px;
		background: linear-gradient(to bottom, #e3f9ff, #fff);
		.arrow {
			@size: 8px;
			width: 0;
			height: 0;
			border: @size solid #a6a8b1;
			border-color: #a6a8b1 transparent transparent transparent;
			position: absolute;
			bottom: -15px;
			left: 10px;
			z-index: 1;
			&::before {
				content: "";
				position: absolute;
				top: calc(-@size - 1px);
				left: -@size;
				border: @size solid #a6a8b1;
				border-color: #fff transparent transparent transparent;
			}
		}
		.top {
			display: flex;
			justify-content: space-between;
			align-items: center;
			font-weight: 550;
			.left {
				font-size: 14px;
			}
			.right {
				font-size: 12px;
			}
		}
		.gift-content {
			margin-top: 15px;
			height: 215px;
			overflow: scroll;
			::v-deep .van-grid-item__content {
				background: none;
			}
			.van-grid-item {
				&.choosed {
					border: 2px solid #00abea;
            		border-radius: 5px;
				}
			}
			.gift-image {
				width: 50px;
				height: 50px;
				img {
					width: 100%;
					height: 100%;
				}
			}
			.name {
				margin-top: 10px;
			}
		}
		.buttom {
			position: absolute;
			bottom: 0;
			left: 0;
			margin-left: 15px;
			display: flex;
			align-items: center;
			height: 40px;
			.account {
				.van-cell {
					margin-left: 20px;
					padding-left: 10px;
					padding-right: 0;
					width: 150px;
				}
			}
			.van-cell {
				display: flex;
				align-items: center;
				margin-left: 10px;
				height: 30px;
				width: 120px;
				border-radius: 15px;
				background-color: #eee;
				padding-left: 5px;
				padding-right: 10px;

				.holder {
					height: 25px;
					width: 25px;
					border-radius: 50px;
					overflow: hidden;
					img {
						width: 100%;
						height: 100%;
					}
				}
				.button {
					background-color: #00abea;
					display: flex;
					align-items: center;
					justify-content: center;
					height: 30px;
					width: 50px;
					border-radius: 15px;
					color: #fff;
					margin-left: 10px;
				}
			}
		}
	}
}
</style>
